
import { luigiMediaArray } from './luigiMedia'
import { frodoReviewerProfile, hollyReviewerProfile, gatsbyReviewerProfile } from './luigiReviewers'
import { frodoBio, hollyBio, luigiBio, gatsbyBio } from './luigiBios'
import { luigiDatingProfileHinge, luigiDatingProfileBumble, luigiDatingProfileTinder } from './luigiDatingProfiles'

export const luigiUser = {
  _id: 'luigiUserId',
  email: 'luigi@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: false,
  reviewerProfilesToSelectFrom: [
    { ...frodoReviewerProfile },
    { ...hollyReviewerProfile },
    { ...gatsbyReviewerProfile }
  ],
  media: [ ...luigiMediaArray ],
  bio: { ...luigiBio },
  datingProfiles: [
    { ...luigiDatingProfileHinge },
    { ...luigiDatingProfileBumble },
    { ...luigiDatingProfileTinder }
  ],
  reviewerProfile: {},
}

export const frodoUser = {
  _id: 'frodoUserId',
  email: 'frodo@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...frodoBio },
  datingProfiles: [],
  reviewerProfile: { ...frodoReviewerProfile },
}

export const hollyUser = {
  _id: 'hollyUserId',
  email: 'holly@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...luigiBio },
  datingProfiles: [],
  reviewerProfile: { ...hollyReviewerProfile },
}

export const gatsbyUser = {
  _id: 'gatsbyUserId',
  email: 'gatsby@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...gatsbyBio },
  datingProfiles: [],
  reviewerProfile: { ...gatsbyReviewerProfile },
}
